export default __webpack_public_path__ + "static/media/19.11b2b360.jpeg";